import styled from '@emotion/styled';

const TitleContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
});

export default TitleContainer;
